export const languageStorageKey = 'language-storage-key';
export const storeStorageKey = 'store-storage-key';
export const authenticationStorageKey = 'authentication-storage-key';
export const sessionIdentifierKey = `${authenticationStorageKey}-sessionIdentifierKey`;
